import { render, staticRenderFns } from "./EducationalRatings.vue?vue&type=template&id=53e2005a&"
import script from "./EducationalRatings.vue?vue&type=script&lang=js&"
export * from "./EducationalRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports